export enum ResourceType {
  Solaris = "Solaris",
  Spice = "Spice",
  Water = "Water",
}
